import Modal from 'react-bootstrap/Modal';
import { sanitizeImageUrl } from '../../utils/multiuseFunctions';
import { RustyRoyalCoin } from '../../utils/SvgIcons';

function InvetoryPopupModel(props) {
  const items = props?.item?.length > 0 ? props?.item : [];
  console.log('items', items);
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className="inventory-popup-header">
        <Modal.Title className="" id="contained-modal-title-vcenter">
         Bets Item
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className='container marketplace-container'>
            {items?.length > 0 ? (
              items.map((el, i) => (
                <div className='marketplace-item' key={i}>
                  <p className='marketplace-price allign-of-coins-global'>
                   <RustyRoyalCoin size={16}/> {parseFloat(el?.price)?.toFixed(2) || 0.0}
                  </p>
                  <span className='marketplace-image '>
                    <img
                      src={
                        el?.image?.startsWith('http') ||
                        el?.bannerImage?.startsWith('https')
                          ? sanitizeImageUrl(el?.image || el?.bannerImage)
                          : `https://steamcommunity.com/economy/image/${
                              el?.image || el?.bannerImage
                            }`
                      }
                      alt='Coin'
                    />
                  </span>
                  <p className='marketplace-name'>
                    {el?.name || el?.market_hash_name || 'N/A'}
                  </p>
                </div>
              ))
            ) : (
              <p>No Data Found</p>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default InvetoryPopupModel;
